import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { OriginalRootState } from 'redux/rootReducer'
import { PaidInvoiceState } from 'typings/reduxStore'

export const initState: PaidInvoiceState = {
  dataList: [],
  invoiceCount: 0,
  isDataLoading: true,
  isInvoiceResponseFail: false,
  invoiceErrorMessage: '',
  isSelectedAll: false,
  selectedItems: [],
  gridOption: {
    limit: 20,
    currentPage: 1,
    invoiceCount: 0,
    accountNumber: '',
    accessToken: ''
  },
  filterOption: { value: 'transactionId', label: 'Invoice NO' },
  recordLimitOption: { value: '', label: '' }
}

const invoiceUpdateSlice = createSlice({
  name: 'invoiceUpdateSlice',
  initialState: initState,
  reducers: {
    updatePaidInvoiceState: (
      state: PaidInvoiceState,
      action: PayloadAction<PaidInvoiceState>
    ) => {
      return {
        ...state,
        ...action.payload
      }
    }
  }
})

export const { updatePaidInvoiceState } = invoiceUpdateSlice.actions

export const selectPaidInvoiceCount = (state: OriginalRootState) =>
  state.paidInvoiceSummary.invoiceCount

export const selectIsPaidInvoicesDataLoading = (state: OriginalRootState) =>
  state.paidInvoiceSummary.isDataLoading

export const selectPaidSelectedInvoices = (state: OriginalRootState) =>
  state.paidInvoiceSummary.selectedItems || []

export default invoiceUpdateSlice.reducer
